import React from 'react';
import { PoweredByComponent } from '../PoweredBy/PoweredByComponent';
import { VerificationService } from '@sheerid/jslib';

interface FormFooterProps {
    verificationService: VerificationService;
    children?: any;
}

const FormFooterComponent = ({ verificationService, children }: FormFooterProps) => {
    return (
        <div className="sid-footer sid-h-small-text sid-l-space-top-md">
            <div className="sid-footer__shield">
                <img
                    title="Powered by SheerID"
                    alt="design element"
                    src="https://s3.amazonaws.com/com.sheerid.resources/common/images/2018/icons/shield-check.svg"
                />
            </div>
            <div>
                <div className="sid-footer__one">
                    {children}
                </div>
                <div className="sid-footer__two">
                    <PoweredByComponent verificationService={verificationService} />
                </div>
            </div>
        </div>
    );
};

export {  FormFooterComponent };
